// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"2bdceb40","548":"8336355a"}[chunkId] + ".chunk.css";
};